import * as React from 'react';
import { Paragraph } from '../typography';
import clsx from 'clsx';
import ListItemIcon from './ListItemIcon';

type Props = {
  id: string;
  text: string;
  disabled?: boolean;
  selected?: boolean;
  icon?: React.ReactNode;
  onClick?: (id: string) => void;
};

const ListItem = ({ id, text, disabled = false, selected = false, icon, onClick }: Props) => {
  const isItemReadonly = onClick === undefined;

  return (
    <li
      aria-disabled={disabled}
      tabIndex={disabled || isItemReadonly ? -1 : 0}
      onClick={onClick ? () => onClick(id) : undefined}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onClick) {
          onClick(id);
        }
      }}
      className={`flex w-full max-w-[250px] items-center rounded-4 p-4 hover:cursor-pointer hover:transition-colors hover:duration-200 ${clsx(
        {
          'pointer-events-none': isItemReadonly,
          'opacity-100': !disabled,
          'pointer-events-none opacity-40': disabled,
          'bg-red-25': selected,
          'hover:bg-red-0': !selected,
        }
      )}`}
    >
      {icon && <ListItemIcon icon={icon} />}
      <Paragraph classes="text-base text-black-100">{text}</Paragraph>
    </li>
  );
};
export default ListItem;
